export default function () {
  return {
    scope: {

    },
  };
}
